import React, { Component } from 'react';
import InputButton from '../../../../../../components/ZUILib/InputButton';
import commonUtils from '../../../../../../utils/commonUtil';
import * as defaultConst from './../../../../../../utils/clientConstant';

export default class CelebrityInfo extends Component {

  componentWillReceiveProps(nextprops) {
    if (nextprops.seletedCelebrity) {
      setTimeout(() => {
        if (document.querySelector('.showCelebrity')) {
          const box = document.querySelector('.showCelebrity');
          // let winWidth = window.innerWidth;
          box.style.left = 100 + '%';
          // winWidth -= 1;
          box.style.left = 0 + '%';
          document.documentElement.scrollTop = 0;
        }
      }, 100);
    }
  }

  // function for remove coowner
  removeCoOwner = (celebrityInfo, eventID) => {
    this.props.deleteModal(celebrityInfo, eventID);
  }
  deleteCoOwner = (seletedCelebrity, eventID) => {
    const ownerId = seletedCelebrity.repositoryId;
    this.props.removeCoOwner(ownerId, eventID).then((response) => {
      if (response.body.status.status === defaultConst.constAPISuccess) {
        const box = document.querySelector('.showCelebrity');
        let winWidth = window.innerWidth;
        box.style.left = winWidth + 'px';
        winWidth += 1;
        box.style.left = winWidth + 'px';
        document.documentElement.scrollTop = 0;
        this.props.resetCelebrityAfterDelete();
        this.props._getEventDetails(eventID);
      }
    });
  }
  getAdminLabel = (celebrity) => {
    if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
      return <p className="admin">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
    } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
      return <p className="admin">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
    }
    return <p className="admin">{celebrity.celebrityLabel}</p>;
  }

  getAdminTitle = (celebrity) => {
    if (celebrity.email && celebrity.title && celebrity.celebrityLabel) {
      return <p className="admin">{celebrity.title} <span>(Administrador)</span></p>;
    } else if (celebrity.email && celebrity.celebrityLabel && !celebrity.title) {
      return <p className="admin">{celebrity.celebrityLabel} <span>(Administrador)</span></p>;
    } else if (celebrity.celebrityLabel && !celebrity.title) {
      return <p className="admin">{celebrity.celebrityLabel}</p>;
    }
    return <p className="admin">{celebrity.title}</p>;
  }
  render() {
    const { seletedCelebrity } = this.props;
    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    const eventID = this.props.eventID;
    const selectedEventConfiguration = this.props.selectedEventConfiguration;
    const removeButton = {
      type: 'button',
      value: 'Eliminar',
      autoFocus: false,
      style: 'btnSecondarySpecial elim',
      onClickHandler: () => this.removeCoOwner(seletedCelebrity, eventID),
    };
    return (
      <div className="myEventContent showCelebrity" style={typeof window !== 'undefined' ? { left: window.innerWidth } : null}>
        {seletedCelebrity ?
          <div className="row">
            <div className="col-xs-12 adminCelebratedInfo">
              {selectedEventConfiguration.showTitle ? this.getAdminTitle(seletedCelebrity) : this.getAdminLabel(seletedCelebrity)}
              {/* {seletedCelebrity.title && <p className="admin">{seletedCelebrity.celebrityLabel && <span> {seletedCelebrity.celebrityLabel}</span>}</p>} */}

              <p className="name">Nombre:
              {seletedCelebrity.firstName ? <span> {commonUtils.sentenceCase(seletedCelebrity.firstName)}</span> : <span> - </span>}
              </p>
              <p className="lastName">Apellido paterno:
              {seletedCelebrity.lastName ? <span> {commonUtils.sentenceCase(seletedCelebrity.lastName)}</span> : <span> - </span>}
              </p>
              <p className="lastNameTwo">Apellido materno:
              {seletedCelebrity.motherName ? <span> {commonUtils.sentenceCase(seletedCelebrity.motherName)}</span> : <span> - </span>}
              </p>
              <p className="nickName">Alias:
               {seletedCelebrity.nickName ? <span> {commonUtils.sentenceCase(seletedCelebrity.nickName)}</span> : <span> - </span>}
              </p>
              <p>Fecha de nacimiento:
               {seletedCelebrity.dateOfBirth ? <span> {commonUtils.sentenceCase(seletedCelebrity.dateOfBirth)}</span> : <span>-</span>}
              </p>
              <p className="tel">Teléfono celular:
               {seletedCelebrity.phone ? <span> {commonUtils.sentenceCase(seletedCelebrity.phone)}</span> : <span> - </span>}
              </p>
              <p className="correo">Correo electrónico:
             {seletedCelebrity.email ? <span> {seletedCelebrity.email}</span> : <span> - </span>}
              </p>
            </div>
          </div>
          : null}
        {seletedCelebrity ?
          <div className="row">
            <div className="col-xs-12 adminCelebratedButton editAdmin">
              {(seletedCelebrity.displayEditButton === 'true' && eventStatusForSuspended === false) ? <a className="btnPrimaryAction" onClick={this.props.showCelebityEditingSection}>Editar</a> : null}
              {(seletedCelebrity.displayEliminarButton === 'true' && eventStatusForSuspended === false) ? <InputButton buttonAttr={removeButton} /> : null}
            </div>
          </div> : null}
      </div>
    );
  }


}
